import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsRendererComponent } from './settings-renderer.component';
import { DxColorBoxModule, DxDataGridModule, DxTextBoxModule, DxSelectBoxModule } from 'devextreme-angular';



@NgModule({
  declarations: [
    SettingsRendererComponent
  ],
	exports: [
		SettingsRendererComponent
	],
  imports: [
    CommonModule,

		DxDataGridModule,

		DxColorBoxModule,
		DxSelectBoxModule,
		DxTextBoxModule,
  ]
})
export class SettingsRendererModule { }
